import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, finalize, map } from 'rxjs';
import { AgreementService } from 'src/app/admin/data-access/agreement.service';

interface AgreementCheckboxView {
  agreement_id: string;
  name: string;
  completed: boolean;
  agreement_text: string;
}

@Component({
    selector: 'loginResearch',
    templateUrl: './loginResearch.html',
    standalone: false
})
export class LoginResearchComponent implements OnInit, OnDestroy {
  data: AgreementCheckboxView[] = [];
  allComplete = false;
  panelOpenState = false;

  // maps agreement data to AgreementCheckboxView interface while also listening to when the observer completes
  optionalAgreements$: Observable<AgreementCheckboxView[]> =
    this.agreementService.nextOptionalAgreements$.pipe(
      map((agreements) =>
        agreements.map((agreement) => agreement as AgreementCheckboxView)
      ),
      finalize(() => this.router.navigate(['dashboard']))
    );

  // subscribes to the optionalAgreements$ observable so it localizes the data to perform operations like checkAll
  optionalAgreementsSub: Subscription = this.optionalAgreements$.subscribe(
    (agreements) => {
      this.data = agreements;
    }
  );

  constructor(
    private router: Router,
    private agreementService: AgreementService
  ) {}

  ngOnInit() {}

  ngOnDestroy(): void {
    this.optionalAgreementsSub.unsubscribe();
  }

  continue() {
    let acceptIds = '';
    let rejectIds = '';
    this.data.forEach((t) => {
      if (t.completed) acceptIds = acceptIds + t.agreement_id + ',';
      else rejectIds = rejectIds + t.agreement_id + ',';
    });
    this.agreementService.acceptOptionalAgreements(acceptIds, rejectIds);
  }

  change(completed: boolean, index: number) {
    this.data[index].completed = completed;
    this.allComplete = this.data != null && this.data.every((t) => t.completed);
  }

  someComplete(): boolean {
    if (this.data == null) {
      return false;
    }
    return this.data.filter((t) => t.completed).length > 0 && !this.allComplete;
  }

  checkForHTMLTags(test?: string): boolean {
    if(test != null)
      return /<\/?[a-z][\s\S]*>/i.test(test)
    else
      return false
  }

  selectAll(completed: boolean) {
    this.allComplete = completed;
    if (this.data.length === 0) return;
    this.data.forEach((t) => (t.completed = completed));
  }
}
